// extracted by mini-css-extract-plugin
export default {"factories":"Factories_factories__yK9kZ","stem":"Factories_stem__B7EcU"};